/*
*###############################################################################
*Module Name                   : DPSearchBoxDynamic.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"

import "../../assets/scss/datatables.scss"

import ReactPaginate from 'react-paginate';
import "../../assets/scss/searchtable.scss"



const DPDynamicTablePopUp = (props) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [count, setCount] = useState(props?.data.length ?? 0);

    const indexOfLastPost = currentPage * pageSize
    const indexOfFirstPost = indexOfLastPost - pageSize

    const currentPosts = props.data.slice(indexOfFirstPost, indexOfLastPost)

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    useEffect(() => {
        setCount(props?.data.length ?? 0);
        setCurrentPage(1);
    }, [props.isOpen])

    return (
        <div
        >
            <Modal
                id="dynamicSearchModal"
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
                centered
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{props.SubTitle} </CardTitle>
                                    <p className="card-title-desc">
                                        {props.Details}
                                    </p>
                                    <>
                                        <table className="table table-bordered  table-sm rounded" style={{ fontSize: "11px" }} id={"TaxmodeDet"}>
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Transaction Date</th>
                                                    <th>Transaction type</th>
                                                    <th>Reference 1</th>
                                                    <th>Reference 2</th>
                                                    <th>Ref Type</th>
                                                    <th>Ref Number</th>
                                                    <th style={{ textAlign: "right" }}>Gross amount</th>
                                                    <th style={{ textAlign: "right" }}>Discount Amt</th>
                                                    <th style={{ textAlign: "right" }}>Discount Per</th>
                                                    <th style={{ textAlign: "right" }}>Net Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody disabled={true}>
                                                {(currentPosts || []).map((values, index) => (
                                                    <tr>
                                                        <td style={{ width: "100px", margin: "auto" }}>{values.heD_TXNDATE.slice(0, 10)}</td>
                                                        <td style={{ width: "200px", margin: "auto" }}>{values.heD_TYPE}</td>
                                                        <td style={{ width: "100px", margin: "auto" }}>{values.heD_REF1}</td>
                                                        <td style={{ width: "100px", margin: "auto" }}>{values.heD_REF2}</td>
                                                        <td style={{ width: "100px", margin: "auto" }}>{values.heD_REFTYPE}</td>
                                                        <td style={{ width: "100px", margin: "auto" }}>{values.heD_REFNO}</td>
                                                        <td style={{ textAlign: "right", width: "100px" }}>{(values.heD_GROAMT).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                                                        <td style={{ textAlign: "right", width: "80px" }}>{(values.heD_DISAMT).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                                                        <td style={{ textAlign: "right", width: "80px" }}>{(values.heD_DISCPER).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                                                        <td style={{ textAlign: "right", width: "100px" }}>{(values.heD_NETAMT).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="6" style={{ textAlign: "right" }}>Total</td>
                                                    <td style={{ textAlign: "right" }}>{(props?.data.reduce((a, b) => a + parseFloat(b.heD_GROAMT), 0)).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                                                    <td style={{ textAlign: "right" }}>{(props?.data.reduce((a, b) => a + parseFloat(b.heD_DISAMT), 0)).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                                                    <td colSpan="1" style={{ textAlign: "right" }}></td>
                                                    <td style={{ textAlign: "right" }}>{(props?.data.reduce((a, b) => a + parseFloat(b.heD_NETAMT), 0)).toLocaleString(undefined, { minimumFractionDigits: 2, })}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </>
                                    <div className="row-fluid">

                                        <div className="col-12" style={{ display: "inline-block" }}>
                                            <ReactPaginate
                                                previousLabel={'Previous'}
                                                nextLabel={'Next'}
                                                breakLabel={'...'}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                pageCount={Math.ceil(count / pageSize)}
                                                pageRangeDisplayed={2}
                                                onPageChange={handlePageClick}
                                                forcePage={currentPage - 1}
                                                renderOnZeroPageCount={null}
                                                activeClassName={'active'}
                                                activeLinkClassName={'page-link'}
                                                containerClassName={'pagination justify-content-end pagination-sm'}
                                            />
                                        </div>
                                    </div>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </Modal>

        </div>
    );
}

export default DPDynamicTablePopUp;









